import { render } from "./BienBanConfirmButton.vue?vue&type=template&id=e89d07be&ts=true"
import script from "./BienBanConfirmButton.vue?vue&type=script&lang=ts"
export * from "./BienBanConfirmButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__